export function isNullOrUndefined(value: any): boolean {
  return value === undefined || value === null;
}

// Match tolerante para autocompletes de filtros:
// - insensible a mayusculas
// - insensible a acentos y enie (via NFD + strip de diacriticos)
// - por-palabra: cada token del query tiene que aparecer como substring
//   del texto normalizado. Asi "pastilla de freno" matchea
//   "JUEGO DE PASTILLAS DE FRENO" (pastilla es substring de pastillas).
export function softMatch(text: string, query: string): boolean {
  if (isNullOrUndefined(text) || isNullOrUndefined(query)) return false;
  const normalize = (s: string) => String(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const normalizedText = normalize(text);
  const tokens = normalize(query).split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  return tokens.every(tok => normalizedText.includes(tok));
}

export function getCustomer(): any {
  const user = JSON.parse(localStorage.getItem('user') ?? 'null');
  if (!isNullOrUndefined(user) && !isNullOrUndefined(user.user)) {
    return user.user.customer;
  }
  return null;
}

export function getToken(): any {
  return localStorage.getItem('token');
}

export function hasPriceList(customer: any): boolean {
  // El ERP devuelve lprecio__des vacío (y lprecio__descuento en 0, no null)
  // cuando el cliente no tiene lista asignada.
  return !isNullOrUndefined(customer)
    && String(customer.lprecio__des ?? '').trim() !== ''
    && customer.lprecio__descuento != null;
}

export function getDiscount(): number {
  const customer: any = getCustomer();

  // Si el customer viene con lista de precios asignada, usar esa lista
  // (aplica a mayoristas y a minoristas con lista propia).
  if (hasPriceList(customer)) {
    return Number(customer.lprecio__descuento);
  }

  // Anonimos o customers sin lista asignada: usar la LISTA WEB que se carga
  // al iniciar la app desde /price-list.
  const priceLists = JSON.parse(localStorage.getItem('price-list') ?? 'null');
  if (priceLists) {
    const defaultPriceList = priceLists.filter((x: any) => {
      return x.des && x.des.includes('LISTA WEB');
    });
    if (defaultPriceList.length > 0) {
      return Number(defaultPriceList[0].descuento);
    }
  }

  return 0.0;
}

export function getIntervalsOfStock(): any {
  const value = localStorage.getItem('intervals');
  if (!isNullOrUndefined(value)) {
    return JSON.parse(value as string);
  }
  return null;
}

export function getOffers(product: any, value: string): any {
  const values = [];
  if (!isNullOrUndefined(product) && !isNullOrUndefined(product.offers)) {
    const offers: any[] = product.offers;
    let amount = 0.0;
    let minimum = 0;
    let maximum = 0;
    let percentage = 0;

    if (offers.length > 1) {
      for (let i = 0; i < offers.length - 1; i++) {
        amount = getOfferPriceMarkup(offers[i], value);
        minimum = offers[i].cantidadMinima;
        maximum = offers[i + 1].cantidadMinima - 1;
        percentage = offers[i].porcentajeDescuento;
        values.push({ description: `${minimum} a ${maximum} unidades`, amount, minimum, maximum, percentage });
      }
      amount = getOfferPriceMarkup(offers[offers.length - 1], value);
      minimum = offers[offers.length - 1].cantidadMinima;
      percentage = offers[offers.length - 1].porcentajeDescuento;
      maximum = 999999999;
      values.push({ description: `${minimum} a + unidades`, amount, minimum, maximum, percentage });
    } else if (offers.length === 1) {
      amount = getOfferPriceMarkup(offers[0], value);
      minimum = offers[0].cantidadMinima;
      percentage = offers[0].porcentajeDescuento;
      maximum = 999999999;
      values.push({ description: `${minimum} a + unidades: $`, amount, minimum, maximum, percentage });
    }
  }
  return values;
}

export function getOfferPriceMarkup(offer: any, value: string): number {
  if (!isNullOrUndefined(offer)) {
    if (value === '') return offer.precioNetoContado;
    if (value === 'brand') return offer.precioNetoContadoMarca;
    if (value === 'brand_iva') return offer.precioNetoContadoMarcaIva;
  }
  return 0;
}

export function getHeightOfListProduct(listOfProduct: any[]): number {
  const numberOfRows = Math.ceil(listOfProduct.length / 3);
  const numberOfSpaceBetweenRows = numberOfRows - 1;
  return (60 * numberOfRows) + (48 * numberOfSpaceBetweenRows) + (24 * 2);
}

export function getPeriod(value: string): any {
  if (!value) return null;
  const date = new Date(value);
  if (isNaN(date.getTime())) return null;
  return date.getDate().toString() + '/' + (date.getMonth() + 1);
}

export function getTodayIsoString(): string {
  const toffs = (new Date()).getTimezoneOffset() * 60000;
  return (new Date(Date.now() - toffs)).toISOString().substr(0, 10);
}

export function getOfferPrice(quantity: number, price: number, offers: any[]): any {
  if (!isNullOrUndefined(offers)) {
    for (const offer of offers) {
      if (quantity >= offer.minimum && quantity <= offer.maximum) {
        return { amount: offer.amount, percentage: offer.percentaje };
      }
    }
  }
  return { amount: price, percentage: 0 };
}
